import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightWords'
})
export class HighlightWordsPipe implements PipeTransform {
  transform(value: string, wordsToHighlight: string[], cssClass: string = 'bh-highlight'): string {
    if (!value || !wordsToHighlight || wordsToHighlight.length === 0) {
      return value;
    }

    // Экранируем специальные символы для использования в регулярных выражениях
    const escapedWords = wordsToHighlight.map(word => word.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'));

    // Создаем регулярное выражение для поиска слов, которые нужно выделить
    const regex = new RegExp(`\\b(${escapedWords.join('|')})\\b`, 'gi');

    // Заменяем найденные слова на их обертку с классом
    return value.replace(regex, `<span class="${cssClass}">$1</span>`);
  }
}
